/** input[type=date] 용 YYYY-MM-DD 헬퍼 */

export function toInputDate(value: Date = new Date()): string {
  const y = value.getFullYear()
  const m = String(value.getMonth() + 1).padStart(2, '0')
  const d = String(value.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function monthsAgoInputDate(months: number, from: Date = new Date()): string {
  const date = new Date(from)
  date.setMonth(date.getMonth() - months)
  return toInputDate(date)
}

export function daysAgoInputDate(days: number, from: Date = new Date()): string {
  const date = new Date(from)
  date.setDate(date.getDate() - days)
  return toInputDate(date)
}

export type DatePresetKey = '7d' | '1m' | '3m' | '6m' | 'all'

export const DATE_PRESETS: Array<{ key: DatePresetKey; label: string }> = [
  { key: '7d', label: '1주일' },
  { key: '1m', label: '1개월' },
  { key: '3m', label: '3개월' },
  { key: '6m', label: '6개월' },
  { key: 'all', label: '전체' },
]

export function rangeFromPreset(key: DatePresetKey): { from: string; to: string } {
  const to = toInputDate()
  switch (key) {
    case '7d':
      return { from: daysAgoInputDate(7), to }
    case '1m':
      return { from: monthsAgoInputDate(1), to }
    case '3m':
      return { from: monthsAgoInputDate(3), to }
    case '6m':
      return { from: monthsAgoInputDate(6), to }
    case 'all':
    default:
      return { from: '', to: '' }
  }
}

/** dateStr 가 from~to(YYYY-MM-DD) 안에 있는지. from/to 비우면 해당 쪽 제한 없음 */
export function isInDateRange(dateStr: string | null | undefined, from: string, to: string): boolean {
  if (!from && !to) return true
  const raw = String(dateStr || '').slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return !from && !to
  if (from && raw < from) return false
  if (to && raw > to) return false
  return true
}
